<script>
export default {
  name: 'Banner',
  data() {
    return {
      list: [
        {
          text: 'Более 30 лет на автомобильном рынке',
        },
        {
          text: 'Высокий уровень экспертизы',
        },
        {
          text: 'Высококвалифицированные менеджеры',
        },
      ],
    };
  },
};

</script><template>
  <div class="section section_gray section_indents">
    <div class="container">
      <div class="flex flex-col-reverse sm:flex-row items-center rounded-big-brand bg-white">
        <div class="w-full sm:w-1/2 xl:w-2/5 pt-0 sm:pt-4 pb-4 sm:py-8 pl-5 sm:pl-10">
          <h2 class="title-h2 mb-6"><span>ПРАГМАТИКА</span> Эксперт это:</h2>

          <div class="-mt-4 check-green">
            <div
              class="flex mb-2"
              v-for="(item, index) in list"
              :key="index"
            >
              <svg class="w-[20px] h-[20px] mr-2">
                <use xlink:href="/public/images/svg/sprite.svg#check-green"></use>
              </svg>
              <span
                v-html="item.text"
                class="text-gray-600"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
